export enum stateType {
  PROCESSING = "PROCESSING",
  PENDING = "PENDING",
  READY = "READY",
  ERROR = "ERROR",
}
export type tableOrderType = "asc" | "desc";
